import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { useIntl } from 'react-intl';
import { Refresh } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  title: {
    textTransform: props => props.transform,
    '&:not(:first-child)': {
      marginTop: theme.spacing(2)
    }
  }
}));

export function SectionHeader({
  translationId,
  children,
  transform = 'uppercase',
  refreshIconShow = false,
  onRefreshMainImage,
  isDisable
}) {
  const classes = useStyles({ transform });
  const { formatMessage } = useIntl();
  const content = translationId
    ? formatMessage({ id: translationId })
    : children;
  return (
    <>
      <Typography className={classes.title} variant="subtitle1">
        {content}{' '}
        {refreshIconShow && (
          <IconButton
            onClick={onRefreshMainImage}
            color="secondary"
            size="medium"
            disabled={isDisable}
          >
            <Refresh color="blue" />
          </IconButton>
        )}
      </Typography>
      <Divider />
    </>
  );
}

export default SectionHeader;
